import { getIsAuthError } from '../constants/error-codes';

export interface ErrorResult {
  errorCode?: string;
  errorMessage?: string;
}

export interface ErrorResponse {
  message: string;
  graphQLErrors: {
    message: string;
    extensions: ErrorExtension;
  }[];
}
interface ErrorDetail {
  errorCode: string;
  errorMessage: string;
}

interface ErrorExtension {
  errors: ErrorDetail[];
}

export const isDataModelError = (error: ErrorResponse | Error): boolean => {
  return !!(error && error.message && error.message.includes('GQL Error'));
};

export const extractErrorCode = (errorMessage: string): string | undefined => {
  const errorPattern = /[A-Z]+_[A-Z]+_\d+/;
  if (errorMessage) {
    const match = errorMessage.match(errorPattern);
    if (match) {
      return match[0];
    }
  }
  return undefined;
};
export const trackGraphQlError = (response: ErrorResponse): ErrorResult => {
  if (getIsAuthError(response)) {
    return { errorCode: 'AUTH_ERR_105' };
  }

  const firstError =
    response?.graphQLErrors && response.graphQLErrors.length > 0
      ? response.graphQLErrors[0]
      : undefined;

  if (!firstError) {
    return response.message
      ? { errorMessage: response.message }
      : { errorMessage: 'No errorMessage provided' };
  }

  if (firstError.message?.length > 0) {
    const errorCode = extractErrorCode(firstError.message);
    return errorCode ? { errorCode } : { errorMessage: firstError.message };
  }
  return { errorMessage: 'No errorMessage provided' };
};

export const getAllErrorCodes = (response: ErrorResponse): string[] => {
  const errorCodes = (response.graphQLErrors || [])
    .flatMap((graphQLError) => graphQLError.extensions?.errors ?? [])
    .map((error) => error.errorCode)
    .filter(Boolean);

  return errorCodes;
};
